import React from "react";
import {AuctionsManager} from "@nextlot/core/webcast";
import {CORE_VERSION} from "@nextlot/core/index";
import {useAppSelector} from "@nextlot/core/webcast/hooks";

// @ts-ignore
const webAppBuildTag = __BUILD_TAG__;

export default function WebcastPageFooterLineCmp(props:{screenName: 'Clerk'|'Bidder'|'Auctioneer'|'Onsite'}) {

    const wbsVersionBuildTag = useAppSelector(reduxState => reduxState.activeWebcast.wbsNetworkStatus.wbsVersionBuildTag);
    const wbsRoundTripMilliseconds = useAppSelector(reduxState => reduxState.activeWebcast.wbsNetworkStatus.roundTripMilliseconds);


    return (
        <div className="webcast-page-footer-container">
            <div>Webcast{props.screenName}#{webAppBuildTag} / core({CORE_VERSION.buildTag}
                [wbs#{wbsVersionBuildTag} &gt;
                {AuctionsManager.currentWebcastAuctionHandler?.auctionConnectData?.wbsHostname}: {wbsRoundTripMilliseconds}ms]</div>
        </div>
    )
}
